var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('Spinner',{staticClass:"d-inline-block mr-1 mb-n1",attrs:{"size":18,"line-fg-color":_vm.color,"line-bg-color":"transparent"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }